var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAppForm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3436 3.86856L8.5897 2.04163V2.80398C8.5897 3.38965 9.06629 3.86681 9.65137 3.86856H10.3436ZM8.07584 0.676213H4.42639H4.41648C2.97973 0.676213 1.78448 1.84171 1.75064 3.28896V9.52888C1.71856 11.0006 2.88989 12.2245 4.36106 12.2577H4.42464L9.10239 12.2571C10.5683 12.1976 11.7081 11.0018 11.6976 9.53821V4.19138C11.6976 4.0788 11.6539 3.96971 11.5757 3.88863L8.62114 0.81038C8.53831 0.72463 8.42456 0.676213 8.30556 0.676213H8.22856C8.20376 0.671843 8.17825 0.669563 8.1522 0.669563C8.12616 0.669563 8.10064 0.671843 8.07584 0.676213ZM7.7147 1.55121V2.80398C7.7147 3.87031 8.5827 4.74065 9.6502 4.74356H10.8226V9.54171C10.8296 10.5334 10.0585 11.3425 9.08489 11.3827H4.38089C3.39156 11.3605 2.60406 10.5375 2.62564 9.53821V3.29946C2.64839 2.33405 3.45106 1.55121 4.41764 1.55121H4.42464H7.7147ZM8.04323 8.89929H4.89324C4.65174 8.89929 4.45574 8.70329 4.45574 8.46179C4.45574 8.22029 4.65174 8.02429 4.89324 8.02429H8.04323C8.28474 8.02429 8.48074 8.22029 8.48074 8.46179C8.48074 8.70329 8.28474 8.89929 8.04323 8.89929ZM4.89271 6.71062H6.85038C7.09188 6.71062 7.28788 6.51462 7.28788 6.27312C7.28788 6.03162 7.09188 5.83562 6.85038 5.83562H4.89271C4.65121 5.83562 4.45521 6.03162 4.45521 6.27312C4.45521 6.51462 4.65121 6.71062 4.89271 6.71062Z",
    fill: "#082A51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppForm);
export default __webpack_public_path__ + "static/media/icon-app-form.dd9e7a2bde76b976bec22a07ab63cc2a.svg";
export { ForwardRef as ReactComponent };